import styled from 'styled-components';

export const Card = styled.div`
  border-radius: 4px;
  box-shadow: 0 0 20px
    ${(props) => props.theme.grey.mix(props.theme.white, 0.9).string()};
  padding: 1rem;
`;
